function initLoadMore() {
	$('.js-load-more').on('click', function() {
		var _this = this;
		$(this).addClass('state-loading');

		setTimeout(function() {
			$(_this).removeClass('state-loading');
		}, 4000);
	});
}

export function init() {
	initLoadMore();
}
